import React, { useState, useEffect } from "react";
import MainLayouts from "../../Layout/MainLayouts";
import { ReactComponent as List } from "bootstrap-icons/icons/list.svg";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import ApiServices from "../../api/ApiServices";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { handleError } from "../../components/utils/AuthenticationCheck";
import AxiosApiCall from "../../api/AxiosApiCall";

const CreateSecurityQuestion = () => {
    const [questionText, setQuestionText] = useState("");
    const [description, setDescription] = useState("");
    const [isActive, setIsActive] = useState(true);
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();
    const axios = AxiosApiCall();

    // ---------------- Submit ----------------
    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validation
        if (!questionText.trim()) {
            toast.error("Question text is required.");
            return;
        }

        if (questionText.length < 3) {
            toast.error("Question text must be at least 3 characters long.");
            return;
        }

        setLoading(true);

        // Build payload
        const formData = {
            question_text: questionText.trim(),
            is_active: isActive,
        };

        // Add description only if provided
        if (description.trim()) {
            formData.description = description.trim();
        }

        // console.log("API Payload:", formData);

        try {
            const authData = JSON.parse(localStorage.getItem("auth"));
            const token = authData?.token;
            if (!token) throw new Error("No access token found.");

            const response = await axios.post(ApiServices.createSecurityQuestion, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                },
                withCredentials: true,
            });

            const { status, message } = response.data;
            if (status === 200 || status === "200") {
                navigate("/admin/security/question/list");
                toast.success(message || "Security question created successfully!");

                // Reset form
                setQuestionText("");
                setDescription("");
                setIsActive(true);
            } else {
                handleError({ response: { status, data: { message } } }, navigate);
            }
        } catch (error) {
            handleError(error, navigate);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <MainLayouts>
                <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
                    {/* Breadcrumb */}
                    <section className="w-full pr-[3%] pt-3 my-3" style={{ backgroundColor: "#F7F7F7" }}>
                        <nav className="bg-gray-200 py-0 px-4 rounded-lg">
                            <ol className="list-none p-0 inline-flex mb-2">
                                <li className="flex items-center">
                                    <p className="text-darkGreen3 pr-2">Security</p>
                                    <ChevronRightIcon />
                                </li>
                                <li className="flex items-center">
                                    <p className="text-darkGreen3 pr-2">Questions</p>
                                    <ChevronRightIcon />
                                </li>
                                <li className="flex items-center">
                                    <p className="text-orange1">Create</p>
                                </li>
                            </ol>
                        </nav>
                    </section>

                    {/* Form */}
                    <section className="gray_background">
                        <div className="container px-1 pb-2 mx-auto">
                            <div className="lg:w-full bg-white rounded-lg py-3 px-2 shadow-md" style={{ backgroundColor: "#F7F7F7" }}>
                                <form onSubmit={handleSubmit}>
                                    {/* Question Text */}
                                    <div className="mb-6">
                                        <label htmlFor="questionText" className="block mb-2 text-sm font-medium text-gray-900">
                                            Question Text *
                                        </label>
                                        <input
                                            type="text"
                                            id="questionText"
                                            value={questionText}
                                            onChange={(e) => setQuestionText(e.target.value)}
                                            className="border border-dGrey1 text-gray-900 text-sm rounded-lg block w-full p-2.5 focus:ring-2 focus:ring-darkGreen3 focus:border-transparent"
                                            placeholder="Enter the security question text"
                                            required
                                            maxLength={200}
                                        />
                                        <p className="mt-1 text-xs text-gray-500">
                                            This is the question that users will see when selecting security questions.
                                        </p>
                                    </div>

                                    {/* Description (Optional) */}
                                    <div className="mb-6">
                                        <label htmlFor="description" className="block mb-2 text-sm font-medium text-gray-900">
                                            Description (Optional)
                                        </label>
                                        <textarea
                                            id="description"
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}
                                            rows={4}
                                            className="border border-dGrey1 text-gray-900 text-sm rounded-lg block w-full p-2.5 focus:ring-2 focus:ring-darkGreen3 focus:border-transparent"
                                            placeholder="Optional: Add a description or instructions for this question"
                                            maxLength={500}
                                        />
                                        <p className="mt-1 text-xs text-gray-500">
                                            This description can help users understand what type of answer is expected.
                                        </p>
                                    </div>

                                    {/* Active Status */}
                                    <div className="flex items-center mb-6 p-4 bg-gray-50 rounded-lg border border-gray-200">
                                        <input
                                            type="checkbox"
                                            id="isActive"
                                            checked={isActive}
                                            onChange={(e) => setIsActive(e.target.checked)}
                                            className="w-4 h-4 text-darkGreen3 bg-gray-100  rounded focus:ring-darkGreen3 focus:ring-2"
                                        />
                                        <div className="ml-3">
                                            <label htmlFor="isActive" className="text-sm font-medium text-gray-900">
                                                Active Status
                                            </label>
                                            <p className="text-xs text-gray-500">
                                                {isActive
                                                    ? "This question will be available for users to select."
                                                    : "This question will be hidden and unavailable for selection."
                                                }
                                            </p>
                                        </div>
                                    </div>

                                  

                                    {/* Buttons */}
                                    <div className="flex flex-col gap-4 md:flex-row md:justify-end mt-6 pt-4 ">
                                        <Link
                                            to="/admin/security/question/list"
                                            className="text-lGrey3 py-3 bg-black1 hover:bg-gray-700 font-medium rounded-lg text-sm px-5 flex items-center justify-center transition-colors duration-200"
                                        >
                                            <List className="mr-2" />
                                            Back To List
                                        </Link>
                                        <button
                                            type="submit"
                                            className={`text-lGrey bg-darkGreen3 py-3 px-6 rounded-lg font-medium text-sm flex items-center justify-center ${loading ? "opacity-50 cursor-not-allowed" : "hover:bg-blue-600 transition-colors duration-200"
                                                }`}
                                            disabled={loading}
                                        >
                                            {loading ? (
                                                <>
                                                    <svg className="animate-spin -ml-1 mr-3 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                    </svg>
                                                    Creating...
                                                </>
                                            ) : (
                                                "Create Security Question"
                                            )}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </section>
                </div>
            </MainLayouts>
        </div>
    );
};

export default CreateSecurityQuestion;